import Vue from 'vue';
import { formatErrors } from '@/plugins/debugging';


Vue.mixin({
  methods: {
    // handles error messages that are sent by the backend
    handleErrors(errors) {
      this.showErrorNotification(this.$t(formatErrors(errors)));
    },

    // runs "handleErrors" if errors is defined and not empty list.
    handleOptionalErrors(errors) {
      if (errors && errors.length !== 0) { this.handleErrors(errors); }
    },

    showErrorNotification(message) {
      this.$bus.$emit('notification', message || this.$t('cms.error.General'), 'error');
    },

    showWarningNotification(message) {
      this.$bus.$emit('notification', message || this.$t('cms.error.General'), 'warning');
    },

    showSuccessNotification(message) {
      this.$bus.$emit('notification', message || this.$t('cms.error.Success'), 'success');
    },

    sendNotification(message, type = 'default') {
      if (message) {
        this.$bus.$emit('notification', message, type);
      }
    },
  },
});
